import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search",
  "use": "search-usage",
  "viewBox": "0 0 23 23",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 23 23\" id=\"search\"><path fill=\"#C3C0C4\" fill-rule=\"evenodd\" d=\"M15.429 9.571c0-3.308-2.692-6-6-6s-6 2.692-6 6 2.692 6 6 6 6-2.692 6-6zm6.857 11.143c0 .938-.777 1.715-1.715 1.715a1.68 1.68 0 0 1-1.205-.51l-4.594-4.58A9.407 9.407 0 0 1 9.43 19 9.425 9.425 0 0 1 0 9.571 9.425 9.425 0 0 1 9.429.143a9.425 9.425 0 0 1 9.428 9.428 9.407 9.407 0 0 1-1.66 5.344l4.593 4.594c.308.308.496.75.496 1.205z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol